<div class="container mx-auto mt-10">
  <h2 class="text-2xl font-bold mb-4">Product List</h2>

  <table class="w-full border-collapse border border-gray-300">
    <thead class="bg-gray-200">
      <tr>
        <th class="border p-2">Image</th>
        <th class="border p-2">Name</th>
        <th class="border p-2">Price</th>
        <th class="border p-2">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of products" class="text-center">
        <td class="border p-2">
          <img [src]="environment.apiBaseUrl+product.imagePath" alt="{{ product.name }}" class="h-16 w-16 object-cover mx-auto" />
        </td>
        <td class="border p-2">{{ product.name }}</td>
        <td class="border p-2">৳{{ product.price }}</td>
        <td class="border p-2">
          <button class="bg-blue-500 text-white px-3 py-1 rounded mr-2 hover:bg-blue-600"
                  (click)="onEdit(product.id)">
            Edit
          </button>
          <button class="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  (click)="onDelete(product.id)">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

